webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(49);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORAGE_KEY = 'training-todo';
	
	var schemaData = {
	  problems: [],
	  user: '',
	  newProblem: {
	    name: null,
	    url: null,
	    notes: null
	  },
	  message: '',
	  toEdit: false
	};
	
	var db = {
	  fetch: function fetch() {
	    var data = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
	    data = (0, _assign2.default)(schemaData, data);
	    data.problems.forEach(function (problem, index) {
	      problem.id = index;
	    });
	    return data;
	  },
	  save: function save(data) {
	    window.localStorage.setItem(STORAGE_KEY, (0, _stringify2.default)(data));
	  },
	  put: function put(att, val) {
	    var cur = db.fetch();
	    cur[att] = val;
	    db.save(cur);
	  }
	};
	
	new _vue2.default({
	  el: '#app',
	  template: '<App is="app"\n    v-bind:problems="problems"\n    v-bind:user="user"\n    v-bind:newProblem="newProblem"\n    v-bind:message="message"\n    v-bind:toEdit="toEdit"\n    v-on:addProblem="addProblem"\n    v-on:editProblem="editProblem"\n    v-on:removeProblem="removeProblem"\n    v-on:changeUser="changeUser"\n    v-on:doneEdit="doneEdit"\n    />',
	  components: { App: _App2.default },
	  data: db.fetch(),
	  methods: {
	    addProblem: function addProblem() {
	      var name = this.newProblem.name || '';
	      var url = this.newProblem.url || '';
	      var ok = true;
	      if (name.length === 0) {
	        this.message = 'Please provide a name before add';
	        ok = false;
	      }
	      if (url.length === 0) {
	        if (this.message.length > 0) this.message += '. ';
	        this.message += 'Please provide a url';
	        ok = false;
	      }
	      if (!ok) {
	        return;
	      }
	      this.problems.push(this.newProblem);
	      this.newProblem = window.Object.assign({}, schemaData.newProblem);
	      this.message = '';
	      db.put('problems', this.problems);
	    },
	    removeProblem: function removeProblem(problem, index) {
	      this.problems.splice(index, 1);
	      db.put('problems', this.problems);
	    },
	    editProblem: function editProblem(problem, index) {
	      this.newProblem = this.problems[index];
	      this.toEdit = true;
	    },
	    doneEdit: function doneEdit() {
	      this.toEdit = false;
	      this.newProblem = window.Object.assign({}, schemaData.newProblem);
	      db.put('problems', this.problems);
	    },
	    changeUser: function changeUser(newUser) {
	      db.put('user', newUser);
	    }
	  }
	});

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProblemList = __webpack_require__(51);
	
	var _ProblemList2 = _interopRequireDefault(_ProblemList);
	
	var _ProblemForm = __webpack_require__(50);
	
	var _ProblemForm2 = _interopRequireDefault(_ProblemForm);
	
	var _lodash = __webpack_require__(47);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    ProblemList: _ProblemList2.default,
	    ProblemForm: _ProblemForm2.default
	  },
	  data: function data() {
	    return {
	      showUserInput: false,
	      localUser: this.user || 'MP'
	    };
	  },
	  props: ['problems', 'user', 'newProblem', 'message', 'toEdit'],
	  filters: {
	    lowercase: function lowercase(d) {
	      return d.toLowerCase();
	    }
	  },
	  methods: {
	    addProblem: function addProblem() {
	      this.$emit('addProblem');
	    },
	    editProblem: function editProblem(problem, index) {
	      this.$emit('editProblem', problem, index);
	      this.$refs.problemForm.$refs.inputProblemName.focus();
	    },
	    removeProblem: function removeProblem(problem, index) {
	      this.$emit('removeProblem', problem, index);
	    },
	    toggleUserInput: function toggleUserInput() {
	      var _this = this;
	
	      this.showUserInput = !this.showUserInput;
	      _vue2.default.nextTick(function () {
	        if (_this.showUserInput) {
	          _this.$refs.inputUser.focus();
	        }
	      });
	    },
	    closeUser: function closeUser() {
	      this.showUserInput = false;
	    },
	    changeUser: (0, _lodash2.default)(function () {
	      this.$emit('changeUser', this.localUser);
	    }, 500),
	    doneEdit: function doneEdit() {
	      this.$emit('doneEdit');
	    }
	  }
	};

/***/ },

/***/ 13:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'problem-form',
	  props: ['prolems', 'newProblem', 'toEdit'],
	  computed: {
	    desc: function desc() {
	      var name = this.newProblem.name || '';
	      var url = this.newProblem.url || '';
	      if (name.length > 0) {
	        var ref = '<span> @ </span> judge';
	        if (url.length > 0) {
	          ref = '<a href=' + url + '> @ judge </a>';
	        }
	        return name + ref;
	      }
	      return '';
	    }
	  },
	  methods: {
	    addProblem: function addProblem() {
	      this.$emit('addProblem');
	    },
	    doneEdit: function doneEdit() {
	      this.$emit('doneEdit');
	    }
	  }
	};

/***/ },

/***/ 14:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(48);
	
	exports.default = {
	  name: 'problem-list',
	  props: ['problems'],
	  data: function data() {
	    return {
	      msg: 'Manuel'
	    };
	  },
	
	  computed: {
	    compProblems: function compProblems() {
	      if (!this.problems) {
	        return;
	      }
	      var ans = [];
	      for (var i = 0; i < this.problems.length; ++i) {
	        ans.push((0, _assign2.default)({}, this.problems[i]));
	        ans[i].notes = marked(ans[i].notes || '', { sanitize: true });
	      }
	      return ans;
	    }
	  },
	  methods: {
	    edit: function edit(problem, index) {
	      this.$emit('editProblem', problem, index);
	    },
	    removeProblem: function removeProblem(problem, index) {
	      this.$emit('removeProblem', problem, index);
	    }
	  }
	};

/***/ },

/***/ 44:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 45:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 46:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(44)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(45)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7309b6ee"
	
	module.exports = __vue_exports__


/***/ },

/***/ 51:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(46)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(54)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b1fa4470"
	
	module.exports = __vue_exports__


/***/ },

/***/ 52:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('h1', {
	    staticClass: "greeting"
	  }, [_vm._v("Hello " + _vm._s(_vm.localUser) + " !!")]), _vm._v(" "), _c('span', {
	    staticClass: "sub",
	    on: {
	      "click": _vm.toggleUserInput
	    }
	  }, [_vm._v("Not you?")]), _vm._v(" "), (_vm.showUserInput) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localUser),
	      expression: "localUser"
	    }],
	    ref: "inputUser",
	    attrs: {
	      "placeholder": "Insert your name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.localUser)
	    },
	    on: {
	      "keyup": [_vm.changeUser, function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.closeUser($event)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.localUser = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showUserInput) ? _c('span', {
	    on: {
	      "click": _vm.closeUser
	    }
	  }, [_vm._v(" close")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [_c('h3', [_vm._v(" Add new problems to solve (: ")]), _vm._v(" "), _c('h4', {
	    staticClass: "warning"
	  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _vm._v(" "), _c('problem-form', {
	    ref: "problemForm",
	    attrs: {
	      "newProblem": _vm.newProblem,
	      "problems": _vm.problems,
	      "toEdit": _vm.toEdit
	    },
	    on: {
	      "addProblem": _vm.addProblem,
	      "doneEdit": _vm.doneEdit
	    }
	  }), _vm._v(" "), _c('problem-list', {
	    attrs: {
	      "problems": _vm.problems
	    },
	    on: {
	      "editProblem": _vm.editProblem,
	      "removeProblem": _vm.removeProblem
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 53:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('label', [_vm._v(" Name * ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newProblem.name),
	      expression: "newProblem.name"
	    }],
	    ref: "inputProblemName",
	    attrs: {
	      "autofocus": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.newProblem.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newProblem.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(" Url * ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newProblem.url),
	      expression: "newProblem.url"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.newProblem.url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newProblem.url = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(" Notes ")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newProblem.notes),
	      expression: "newProblem.notes"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.newProblem.notes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newProblem.notes = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.toEdit) ? _c('button', {
	    on: {
	      "click": _vm.doneEdit
	    }
	  }, [_vm._v("\n    Edit !\n  ")]) : _c('button', {
	    on: {
	      "click": _vm.addProblem
	    }
	  }, [_vm._v("\n    Add !\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.desc)
	    }
	  })])
	},staticRenderFns: []}

/***/ },

/***/ 54:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "problem-list"
	  }, _vm._l((_vm.compProblems), function(problem, index) {
	    return _c('li', {
	      key: problem.id
	    }, [_c('div', [_c('label', {
	      on: {
	        "dblclick": function($event) {
	          _vm.edit(problem, index)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(index) + " - " + _vm._s(problem.name) + "\n      ")]), _vm._v("\n      @ "), _c('a', {
	      attrs: {
	        "href": problem.url
	      }
	    }, [_vm._v(" judge ")]), _vm._v(" "), _c('button', {
	      staticClass: "destroy",
	      on: {
	        "click": function($event) {
	          _vm.removeProblem(problem, index)
	        }
	      }
	    }, [_vm._v("\n        x\n      ")]), _vm._v(" "), _c('pre', {
	      domProps: {
	        "innerHTML": _vm._s(problem.notes)
	      }
	    })])])
	  }))
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.00e609b569790c683b7f.js